import { Command } from 'commands/Commands';

export class ChangeMemberMobileVisibility extends Command {
  type: string = 'Member.ChangeMobileVisibility';
  priority = 100;
}
